import { object, string } from 'yup'

export const TRANSILE_SCHEMA = object().shape({
  siloDestino: string().required('Debe seleccionar un silo destino').typeError('El campo debe ser texto')
})
